// extracted by mini-css-extract-plugin
module.exports = {"base":"ClusterHistoricalUsageChart_base__2JFB_"};